import { render, staticRenderFns } from "./FooterEmail.vue?vue&type=template&id=d18712a2&scoped=true&lang=pug&"
import script from "./FooterEmail.vue?vue&type=script&lang=js&"
export * from "./FooterEmail.vue?vue&type=script&lang=js&"
import style0 from "./FooterEmail.vue?vue&type=style&index=0&id=d18712a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18712a2",
  null
  
)

export default component.exports